import { t } from "../../validation/validator";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const emailCodec = t.refinement(t.string, (value) => EMAIL_REGEX.test(value), "EmailCodec");

export const SecureRequestSigninLinkRequestSchema = t.type({
  user_email: emailCodec,
});

export const SecureRequestSigninLinkResponseSchema = t.type({
  status: t.string,
  message: t.string,
});

export type SecureRequestSigninLinkResponse = t.TypeOf<typeof SecureRequestSigninLinkResponseSchema>;

export const SecureValidateUserEmailRequestSchema = t.type({
  user_id: t.string,
});

export const SecureValidateUserEmailResponseSchema = t.type({
  status: t.string,
  message: t.string,
});

export type SecureValidateUserEmailResponse = t.TypeOf<typeof SecureValidateUserEmailResponseSchema>;

export const SecureApis = {
  Secure: {
    RequestSigninLink: {
      Name: "secure-secureRequestSigninLink",
      Request: SecureRequestSigninLinkRequestSchema,
      Response: SecureRequestSigninLinkResponseSchema,
    },
    ValidateUserEmail: {
      Name: "secure-secureValidateUserEmail",
      Request: SecureValidateUserEmailRequestSchema,
      Response: SecureValidateUserEmailResponseSchema,
    },
  },
};
